/* NewMarketPitch: left contents sidebar fades away near the end of the article (28 Oct 2026).
   Reference point: the "Our methodology" box when the article has one; otherwise (funding-news) 90% of the article.
   It also fades if the end of the article would slide under it. It comes back when the reader scrolls up.
   Loaded from snippets/article-encarts.liquid. The sidebar itself is built by nmp-article.js. */
(function () {
  'use strict';
  var art = document.querySelector('.nmp-art');
  if (!art) return;

  var css = document.createElement('style');
  css.textContent =
    '.nmp-toc.nmp-toc-fx,.nmp-toc-open.nmp-toc-fx{transition:opacity .45s ease,visibility 0s linear 0s}' +
    '.nmp-toc.nmp-toc-gone,.nmp-toc-open.nmp-toc-gone{opacity:0;visibility:hidden;pointer-events:none;transition:opacity .45s ease,visibility 0s linear .45s}';
  document.head.appendChild(css);

  function methodology() {
    var box = null;
    art.querySelectorAll('.container-summary h2, .container-summary .nmp-box-label').forEach(function (h) {
      if (!box && /methodolog/i.test(h.textContent || '')) box = h.closest('.container-summary') || h;
    });
    return box;
  }

  function start(nav) {
    var open = document.querySelector('.nmp-toc-open');
    var els = [nav, open].filter(Boolean);
    var meth = methodology(), queued = false, gone = false;
    els.forEach(function (el) { el.classList.add('nmp-toc-fx'); });
    function update() {
      queued = false;
      var vh = window.innerHeight, r = art.getBoundingClientRect();
      var line = meth ? meth.getBoundingClientRect().top : r.top + r.height * 0.9;
      var navBottom = nav.getBoundingClientRect().bottom;
      var g = line < vh * 0.65 || (navBottom > 0 && r.bottom < navBottom + 24);
      if (g !== gone) { gone = g; els.forEach(function (el) { el.classList.toggle('nmp-toc-gone', g); }); }
    }
    function ask() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    ask();
  }

  function wait() {
    var nav = document.querySelector('.nmp-toc');
    if (nav) { start(nav); return; }
    var mo = new MutationObserver(function () {
      var n = document.querySelector('.nmp-toc');
      if (n) { mo.disconnect(); start(n); }
    });
    mo.observe(document.body, { childList: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wait); else wait();
})();
